/*#__NO_SIDE_EFFECTS__*/
function memo(callback) {
  var result;
  return function () {
    if (result === undefined) result = callback();
    return result;
  };
}

export { memo };